import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=08830602&scoped=true&"
import script from "./transaction.js?vue&type=script&lang=js&"
export * from "./transaction.js?vue&type=script&lang=js&"
import style0 from "./transaction.scss?vue&type=style&index=0&id=08830602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08830602",
  null
  
)

export default component.exports